import GrComponentFactory from "./gr_component_factory";
import GrPropTypes from "./shared/gr_prop_types";
import Spinner from "./spinner";
import ReadingChallengeActions from "../react_actions/reading_challenge_actions";
import ReadingChallengeBadge from "./reading_challenge/reading_challenge_badge";

export default GrComponentFactory.createClass({
  displayName: "ReadingChallengeEdit",
  propTypes: {
    challenge: GrPropTypes.readingChallenge().isRequired,
    showLoadingSpinner: React.PropTypes.bool.isRequired,
    booksToRead: React.PropTypes.number,
    enableUrcUpdates: React.PropTypes.bool,
  },

  startChallenge() {
    if (this.props.enableUrcUpdates) {
      window.location = "/readingchallenges/annual";
    } else if (this.props.booksToRead > this.props.challenge.maxGoal) {
      window.alert(`Your goal number of books is too high! It must be less than ${this.props.challenge.maxGoal}`);
    } else {
      ReadingChallengeActions.startChallenge();
    }
  },

  renderButtonOrSpinner() {
    if (this.props.showLoadingSpinner) {
      return <Spinner />;
    } else {
      const disabled = this.props.enableUrcUpdates ?
        false : (!this.props.booksToRead || this.props.booksToRead <= 0);
      return <button disabled={disabled}
                     className="gr-button"
                     onClick={this.startChallenge}
                     aria-label={`Start your ${this.props.challenge.year} reading challenge`}>
               Start Challenge
             </button>;
    }
  },

  render() {
    return <div className="readingChallenge__edit">
             <div className="u-marginBottomSmall">
               Challenge yourself to read more this year!
             </div>
             <div className="gr-mediaBox">
               <div className="gr-mediaBox__media u-marginRightMedium">
                 <ReadingChallengeBadge challenge={ this.props.challenge }/>
               </div>
               {this.props.enableUrcUpdates ? (
                 <div className="gr-mediaBox__desc">
                   {this.renderButtonOrSpinner()}
                 </div>
               ) : (
                 <div className="gr-mediaBox__desc">
                   <div className="u-marginBottomXSmall">
                     I want to read
                   </div>
                   <input type="number"
                          autoComplete="off"
                          disabled={this.props.showLoadingSpinner}
                          placeholder="12"
                          value={this.props.booksToRead}
                          className="u-marginBottomXSmall"
                          aria-label={`Number of books you want to read in ${this.props.challenge.year}`}
                          onChange={(ev) => {
                            ReadingChallengeActions.bookNumChanged(ev.target.value);
                          }} />
                   <div className="u-marginBottomXSmall">
                     books in {this.props.challenge.year}
                   </div>
                   {this.renderButtonOrSpinner()}
                 </div>
               )}
             </div>
             {!this.props.enableUrcUpdates && (
               <small className="u-displayBlock u-marginTopTiny">
                 You can change your goal at any time
               </small>
             )}
           </div>;
  },
});
